import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

type Multimedia = { id: number; title: string; description: string; video_id: string }

export function useGetMultimedia() {
  return useFetch<Multimedia[]>(getAbsoluteServerUrl('/multimedia'), { responseType: 'json' }, [])
}
